module.exports = __webpack_public_path__ + "media/images/logos/ostrava-bdd163a956ec5ed14767ec42bd0424c2.png";